import React, { Component } from 'react';
import { some } from 'lodash';
import Panel from '../../../../components/outline/Panel';
import CheckBox from '../../../../components/input/CheckBox';
import BaseForm from '../../../../components/form/BaseForm';
import Button from '../../../../components/Button';
import Img from '../../../../components/Img';
import { comparePrePropsAndNextProps, setDash } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './BrandExposureSelectorList.scss';

class BrandExposureSelectorList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { brandExposureSelector, addBrandExposureListItem, selectSelectorItem, checkIsDuplicateOnExposureList } =
      this.props;
    const { list, selectedList } = brandExposureSelector;

    return (
      <div className="brand-exposure-selector-list">
        {list.map((item) => {
          return (
            <Panel
              className={`selector-card ${checkIsDuplicateOnExposureList(item.storeId) ? 'selected' : ''}`}
              key={item.storeId}
            >
              <div className="panel-body">
                {/*셀렉터 카드 헤더*/}
                <div className="selector-card-header">
                  <CheckBox
                    checked={some(selectedList, ['storeId', item.storeId])}
                    disabled={checkIsDuplicateOnExposureList(item.storeId)}
                    onChange={(checked) => selectSelectorItem(checked, item)}
                  />

                  <label className="selector-card-header-label">{item.storeName}</label>

                  <Button
                    isRadius
                    color="primary"
                    text="직접 추가"
                    disabled={checkIsDuplicateOnExposureList(item.storeId)}
                    onClick={() => addBrandExposureListItem(item)}
                  />
                </div>

                {/*셀렉터 카드 본문*/}
                <div className="selector-card-content">
                  <div className="selector-card-img">
                    <Img src={item.url} />
                  </div>

                  <div className="selector-card-text">
                    <BaseForm
                      label="입점 일자"
                      content={setDateFormat(item.confirmDate, DATE_FORMAT.YMD_DASH_FORMAT)}
                    />

                    <BaseForm label="판매중인 제품 수" content={setDash(item.saleCount)} />

                    <BaseForm label="브랜드 찜 수" content={setDash(item.likeCount)} />

                    <BaseForm label="메모" content={setDash(item.memo)} />
                  </div>
                </div>
              </div>
            </Panel>
          );
        })}
      </div>
    );
  }
}

export default BrandExposureSelectorList;
